import { motion } from "framer-motion";

export const AuroraBackground = ({ mouse }) => {
  const shiftX = mouse?.x ? mouse.x * 18 : 0;
  const shiftY = mouse?.y ? mouse.y * 18 : 0;

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      <div className="absolute inset-0 bg-ink" />
      <div className="absolute inset-0 bg-brand-radial opacity-90" />
      <motion.div
        style={{ x: shiftX, y: shiftY }}
        transition={{ type: "spring", stiffness: 40, damping: 20 }}
        className="absolute -left-1/4 top-[-10%] h-[60vh] w-[60vw] rounded-full bg-brand-primary/30 blur-[110px] animate-aurora-drift-1"
      />
      <motion.div
        style={{ x: shiftX * -1, y: shiftY * -1 }}
        transition={{ type: "spring", stiffness: 40, damping: 20 }}
        className="absolute right-[-10%] top-[10%] h-[55vh] w-[55vw] rounded-full bg-brand-secondary/25 blur-[120px] animate-aurora-drift-2"
      />
      <div className="absolute bottom-[-15%] left-1/3 h-[45vh] w-[45vw] rounded-full bg-brand-accent/15 blur-[130px]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,#05010A_85%)]" />
    </div>
  );
};
